import script from "./activity-person.vue?vue&type=script&lang=tsx&setup=true"
export * from "./activity-person.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__